// extracted by mini-css-extract-plugin
export default {"root":"shyRWg4DDwwPxaBogMZ4","day":"Kv59tmAXGetqCNph_AXn","loading":"ap8Dk9J543ly8Af7BA8y","placeHolderShimmer":"WGOMbJqa3Z11zPbEQCQk"};